<template>
  <modal
    name="time-out"
    height="auto"
    :minWidth="750"
    :adaptive="true"
    scrollable
    @opened="modalOpened"
    @closed="modalClosed"
    id="timeOutModal"
    :clickToClose="false"
    v-if="hasKiosk"
    class="roundedmodal"
  >
    <div class="p-8">
      <h3 class="text-center text-4xl font-bold">
        {{ lang["continue_ordering"][this.language] }}
      </h3>
      <p class="text-center text-xl">
        {{ lang["touch_screen"][this.language] }}
      </p>
      <div class="w-full flex justify-center mt-6">
        <div class="relative overflow-hidden rounded-full w-fit mr-8" 
        :style="mainButtonRadius">
         
          <Button
            class="relative z-10 left-0 right-0 text-white text-xl bg-red-400"
            :style="makeStyles(cancelButtonBackground)+mainButtonRadius"
            @click="cancelOrder"
            >
             <div
            :class="[
              'transition-background z-20 absolute left-0 right-0 top-0 bottom-0 bg-red-600',
              cancelTimer ? 'w-full' : 'w-0',
            ]"
          :style="{
            transition: `all ${cancelTime}s ease-in-out`,
            background: cancelButtonFillBackground,
          }"
          ></div>          
            <span class="z-30 left-0 right-0 relative text-white text-xl">{{ lang["cancel_order"][this.language] }} ({{
              cancelTime
            }})</span>
            </Button
          >
        </div>
        <div>
          <Button class="bg-blue-600 text-white text-xl"
          :style="makeStyles(continueButtonBackground)+mainButtonRadius"
          @click="cancelTimeOut">
          {{lang["continue_order"][this.language]}}
          </Button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "./Button.vue";
import lang from "../lang";
const defaultCancelTime = 10; // seconds

export default {
  name: "TimeOutModal",
  components: {
    Button,
  },
  data() {
    return {
      defaultCancelTime,
      cancelTimer: null,
      cancelTime : null,
      lang: lang,
    };
  },
  computed: {
    ...mapGetters([
      "menu",
      "idleTimer",
      "showIdleTimerModal",
      "menuHash",
      "hasKiosk",
      "language",
    ]),
    ...mapGetters("Cart", ["cartItems"]),
    ...mapGetters("Theme", ["mainButtonRadius","continueButtonBackground","cancelButtonBackground","cancelButtonFillBackground"]),
    // check if we can show the timeoutmodal or not
    allowModal() {
      const isKioskStartPage = this.$route.name === "KioskStart";
      const hasCartItems = this.cartItems[0] ? true : false;
      return (isKioskStartPage && hasCartItems) || !isKioskStartPage;
    },
  },
  methods: {
    // close all the modals
    closeAllModals() {
      const modalNames = [
        "cart-items",
        "upselling-items",
        "cups",
        "retry-payment",
        "contact-details",
        "languages",
        "time-out",
        "item-modifiers",
        "deleteItem",
        "cancelPermission",
      ];
      modalNames.map((x) => this.$modal.hide(x));
    },
    // start the timer
    startCancelTimer() {
      // make `this` available in callback functions
      const self = this;

      // reset cancelTime so it is x sec each time
      this.cancelTime = (this.menu.kiosk_cancel_duration_seconds ? this.menu.kiosk_cancel_duration_seconds : defaultCancelTime) - 1;
      const t = setInterval(() => {
        self.cancelTime -= 1;
      }, 1000);
      this.cancelTimer = t;
    },
    modalOpened() {
      /**
       * Initiate timer logic
       */
      this.startCancelTimer();
    },
    modalClosed() {
      /**
       * Reset timer logic
       */
      if (this.cancelTimer) clearInterval(this.cancelTimer);
      this.cancelTimer = null;
    },
    // cancel the timeout modal and reset the timer
    cancelTimeOut() {
      this.$modal.hide("time-out");
      this.$store.commit("resetIdleTimer", this.allowModal);
      //   if (this["Cart/cartItems"].lenght > 0) {
      //     this.$store.commit("resetIdleTimer", true);
      //   }
    },
    // cancel the order, close the modals, empty the cart and push to the correct route
    cancelOrder() {
      this.$store.commit("updateSearchItemInput", "")
      this.$store.commit("updateIsSearchKiosk", false)
      this.$store.commit("updateMember", "");
      sessionStorage.removeItem("comoMember");
      sessionStorage.removeItem("comoMemberCode");
      sessionStorage.setItem("isLoyaltyMember",false);
      this.$cookies.remove("e");
      this.$store.commit("Cart/updateCustomer", {
        field: "email",
        value: "",
      });

      this.$cookies.remove("n");
      this.$cookies.remove("p");
      this.$cookies.remove("v");
      this.$store.commit("Cart/updateCustomer", {
        field: "fullName",
        value: "",
      });
      this.$store.commit("Cart/updateCustomer", {
        field: "vatNumber",
        value: "",
      });
      this.$store.commit("Cart/updateCustomer", {
        field: "phone",
        value: "",
      });
      this.closeAllModals();
      this.modalClosed();
      this.cancelTimeOut();
      this.$store.commit("updatePaymentError", false);
      this.$store.commit("updateCancelOrder", true);
      this.$store.commit("Cart/emptyCart");
      this.$router.push({path:"/" + this.menuHash + "/start/kiosk",query:this.$route.query});
    },
  },
  watch: {
    cancelTime(value) {
      // if timeout is over, reset timer
      if (value === 0) {
        clearInterval(this.cancelTimer);
        this.$modal.hide("time-out");
        this.cancelOrder();
      }
    },
  },
  mounted() {
    // reset idle timer if mode is kiosk
    const events = ["mousedown", "keypress", "touchmove", "touchstart"];
    const self = this;
    if (this.hasKiosk)
      events.forEach((eventType) => {
        document
          .querySelector("#timeOutClickable")
          .addEventListener(eventType, () => {
            self.$store.commit("resetIdleTimer", this.allowModal);
          });
      });
  },
};
</script>
